import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { makeGetProductColorIsInWishList } from '../redux/wishList/selectors/WishListSelectors';
import { makeGetBasketPopupCollapseState } from '../redux/basket/selectors/BasketSelector';
import { makeGetProductDefaults, makeGetSelectedColorId } from '../redux/product/selectors/ProductSelector';
import { PriceAmount } from '../components/product-detail/price-amount/PriceAmount';
import { AddToBasketButton } from '../components/product-detail/add-to-basket-button/AddToBasketButton';
import { AddToWishlistButtonAlpha } from '../components/product-detail/add-to-wishlist-button/AddToWishlistButtonAlpha';
import { Box, Stack } from '@yonderland/andes-react';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
export const PriceAmountWithCTAContainer = ({ isShopLanding }) => {
    const { giftCard: { values: { min: minAmount, max: maxAmount, productSize: giftCardSizeCode }, }, currency, } = useAemConfig();
    const isBasketPopupCollapsed = useSelector(makeGetBasketPopupCollapseState());
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const { productCode, productId } = useSelector(makeGetProductDefaults());
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const dispatch = useDispatch();
    const [error, setError] = useState();
    const [amount, setAmount] = useState('');
    const [isAmountInputTouched, setIsAmountInputTouched] = useState(false);
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
    };
    const handleToggleWishlist = () => {
        dispatch(wishListActions.toggleProduct(wishListProduct));
    };
    const validateAmount = (amountValidate) => {
        let errorValidate = '';
        if (amountValidate > Number(maxAmount) || amountValidate < Number(minAmount)) {
            errorValidate = 'general:giftcard.charge';
        }
        else if (!amount) {
            errorValidate = 'checkout:checkout.required';
        }
        return errorValidate;
    };
    const onAmountInputBlur = () => {
        setIsAmountInputTouched(true);
        setError(validateAmount(parseFloat(amount)));
    };
    const onAmountChange = (e) => {
        const amountOf = e.target.value;
        setAmount(amountOf);
        if (isAmountInputTouched) {
            setError(validateAmount(parseFloat(amountOf)));
        }
    };
    const addToBasket = (quantity) => {
        const erroBasket = validateAmount(parseFloat(amount));
        setError(erroBasket);
        if (!erroBasket) {
            dispatch(basketActions.createAddGiftCardAction({
                giftCardSizeCode,
                quantity,
                amount: parseFloat(amount),
            }));
        }
    };
    useEffect(() => {
        if (isBasketPopupCollapsed) {
            setAmount('');
            setIsAmountInputTouched(false);
        }
    }, [isBasketPopupCollapsed]);
    return (_jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(PriceAmount, { error: error, amount: amount, currency: currency, minAmount: minAmount, maxAmount: maxAmount, onInputBlur: onAmountInputBlur, onAmountChange: onAmountChange }), _jsxs(Stack, { gap: "4", wrap: "nowrap", children: [_jsx(Box, { flex: { grow: 1 }, children: _jsx(AddToBasketButton, { onClick: addToBasket }) }), !isShopLanding && (_jsx(AddToWishlistButtonAlpha, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct, buttonProps: {
                            theme: 'branded',
                            variant: 'secondary',
                            inverse: false,
                        } }))] })] }));
};
